/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, inject, ViewChild } from '@angular/core';
import { MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-help-and-documentation',
  imports: [MatSelectionList, MatListOption, FontAwesomeModule],
  templateUrl: './help-and-documentation.component.html',
  styleUrl: './help-and-documentation.component.scss'
})
export class HelpAndDocumentationComponent {
  private readonly routerService = inject(Router);
  readonly faArrowUpRightFromSquare = faArrowUpRightFromSquare;

  @ViewChild(MatSelectionList) selectionList?: MatSelectionList;

  selectionChanged(event: MatSelectionListChange): void {
    const selected = event.options.find((option) => option.selected);
    if (selected) {
      this.routerService.navigateByUrl('/elearning');
      this.selectionList?.deselectAll();
    }
  }
}
